module.exports = __webpack_public_path__ + "static/media/B8.94eb79f0.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B8.png
// module id = 887
// module chunks = 0